import {
  //Class Status
  getEventStudentMessageAction,
  postEventStudentMessageAction,
  updateEventStudentMessageAction,
  deleteEventStudentMessageAction,
} from "@/services/event-student-message-action.service";

// initial state
const state = () => ({
  eventStudentMessageActionModel: {},
});

// mutations
const mutations = {
  setEventStudentMessageActionModel(state, data) {
    state.eventStudentMessageActionModel = data;
  },
};

// actions
const actions = {
  //Class Status
  async loadEventStudentMessageAction(vuexContext, co) {
    return await getEventStudentMessageAction(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      items.map((item, index) => {
        item.index = index + 1;
        item.value = item.id;
        item.label = item.name;
      });
      return items;
    });
  },

  async postEventStudentMessageAction(vuexContext, data) {
    return await postEventStudentMessageAction(data);
  },

  async updateEventStudentMessageAction(vuexContext, data) {
    return await updateEventStudentMessageAction(data);
  },

  async deleteEventStudentMessageAction(vuexContext, data) {
    return await deleteEventStudentMessageAction(data);
  },

  addEventStudentMessageActionModel(vuexContext, data) {
    vuexContext.commit("setEventStudentMessageActionModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
